import BaseComponent from "../BaseComponent";
import ParticleTextureInput from "components/Properties/InputComponents/ParticleTextureInput";
import DirectionInput from "components/Properties/InputComponents/DirectionInput";
import MinMaxInput from "components/Properties/InputComponents/MinMaxInput";
import {NumberSliderInput} from "components/Properties/InputComponents/NumberInput";

const ParticlePropertyComponent = ({selectedObject, inputOnChange, transformOnChange}) => {
  let particleSystem = null;
  let particleTexture = null;
  let particleLife = {};
  let particleLifeMinMax = {};
  let particleMass = {};
  let particleMassMinMax = {};
  let radialVelocity = {};
  let radialDirection = {};

  if (selectedObject.userData.type === "particleSystem") {
    particleSystem = selectedObject.userData.system;

    particleLife = particleSystem.emitters[0].initializers.find(initializer => {
      return initializer.type === "Life";
    });
    particleMass = particleSystem.emitters[0].initializers.find(initializer => {
      return initializer.type === "Mass";
    });
    radialVelocity = particleSystem.emitters[0].initializers.find(initializer => {
      return initializer.type === "RadialVelocity";
    });
    particleTexture = particleSystem.emitters[0].initializers.find(initializer => {
      return initializer.type === "BodySprite";
    })?.properties.texture;

    particleLifeMinMax.min = particleLife.properties.min;
    particleLifeMinMax.max = particleLife.properties.max;
    particleMassMinMax.min = particleMass.properties.min;
    particleMassMinMax.max = particleMass.properties.max;
    radialDirection.x = radialVelocity.properties.x;
    radialDirection.y = radialVelocity.properties.y;
    radialDirection.z = radialVelocity.properties.z;
  }

  if (selectedObject.name === "ParticleSystem" && particleSystem) {
    return (
      <BaseComponent title="Particle Property" foldable={true}>
        <ParticleTextureInput
          name="Particle Texture"
          propertyName="particleTexture"
          inputOnChange={inputOnChange}
          thumbnail={particleTexture}
        />
        <MinMaxInput name="ParticleLife" value={particleLifeMinMax} transformOnChange={transformOnChange} />
        <MinMaxInput name="ParticleMass" value={particleMassMinMax} transformOnChange={transformOnChange} />
        <NumberSliderInput
          name="RadialSpeed"
          value={radialVelocity.properties.radius}
          min={0}
          max={100}
          step={0.1}
          inputOnChange={inputOnChange}
        />
        <DirectionInput name="RadialDirection" value={radialDirection} transformOnChange={transformOnChange} is2D={false} />
        <NumberSliderInput
          name="RadialDegree"
          value={radialVelocity.properties.theta}
          min={0}
          max={180}
          step={1}
          inputOnChange={inputOnChange}
        />
      </BaseComponent>
    );
  } else {
    return null;
  }
};

export default ParticlePropertyComponent;
